exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/**  rel=\"stylesheet/scss\" lang=\"scss\"*/\n/** backgroud */\n/** border */\n/** table */\n/* Popover\n-------------------------- */\n/* Dialog\n-------------------------- */\n[data-v-548596a1]:export {\n  xrColorPrimary: #2362FB;\n}\n.wk-select .el-input[data-v-548596a1] {\n  margin-top: 5px;\n}\n.wk-select .el-radio[data-v-548596a1] {\n  margin: 5px 30px 5px 0;\n}\n", ""]);

// exports
